/*
 * 通知系统多语言配置
 */
export default {
    zh: {
        // 权限询问弹窗
        permissionDialog: {
            title: '提示',
            description: '开启通知，无需停留等待生成完成',
            btnClose: '关闭',
            btnAllow: '允许通知',
        },
        // 浏览器引导弹窗
        guideDialog: {
            title: '通知激活操作指南',
            subtitle: '请按照以下步骤激活通知',
            imagePlaceholder: '图片位置',
            stepAlt: '步骤',
            // Chrome 浏览器步骤
            chrome: {
                step1: '点击更多图标',
                step2: '点击设置',
                step3: '点击隐私与安全',
                step4: '点击网站设置',
                step5: '点击通知',
                step6: '找到WeryAI并点击右侧的更多图标',
                step7: '点击允许',
            },
            // Edge 浏览器步骤
            edge: {
                step1: '点击更多',
                step2: '点击设置',
                step3: '点击隐私、搜索和服务',
                step4: '点击站点权限',
                step5: '点击所有权限',
                step6: '点击通知',
                step7: '在不允许通知内找到WeryAI点击更多图标后再点击允许',
            },
        },
    },
    en: {
        // Permission dialog
        permissionDialog: {
            title: 'Tip',
            description: 'Enable notifications, no need to stay and wait for generation to complete',
            btnClose: 'Close',
            btnAllow: 'Allow Notifications',
        },
        // Browser guide dialog
        guideDialog: {
            title: 'Notification Activation Guide',
            subtitle: 'Please follow the steps below to activate the notification',
            imagePlaceholder: 'Image Position',
            stepAlt: 'Step',
            // Chrome browser steps
            chrome: {
                step1: 'Click the More icon',
                step2: 'Click Settings',
                step3: 'Click Privacy and security',
                step4: 'Click Site settings',
                step5: 'Click Notifications',
                step6: 'Find WeryAI and click the More icon on the right',
                step7: 'Click Allow',
            },
            // Edge browser steps
            edge: {
                step1: 'Click More',
                step2: 'Click Settings',
                step3: 'Click Privacy, search, and services',
                step4: 'Click Site permissions',
                step5: 'Click All permissions',
                step6: 'Click Notifications',
                step7: 'Find WeryAI in blocked notifications, click More icon, then click Allow',
            },
        },
    },
    ja: {
        // 日语
        permissionDialog: {
            title: 'ヒント',
            description: '通知を有効にすると、生成完了を待つ必要がありません',
            btnClose: '閉じる',
            btnAllow: '通知を許可',
        },
        guideDialog: {
            title: '通知アクティベーションガイド',
            subtitle: '以下の手順に従って通知を有効にしてください',
            imagePlaceholder: '画像位置',
            stepAlt: 'ステップ',
            chrome: {
                step1: 'その他のアイコンをクリック',
                step2: '設定をクリック',
                step3: 'プライバシーとセキュリティをクリック',
                step4: 'サイトの設定をクリック',
                step5: '通知をクリック',
                step6: 'WeryAIを見つけて右側のその他のアイコンをクリック',
                step7: '許可をクリック',
            },
            edge: {
                step1: 'その他をクリック',
                step2: '設定をクリック',
                step3: 'プライバシー、検索、サービスをクリック',
                step4: 'サイトのアクセス許可をクリック',
                step5: 'すべてのアクセス許可をクリック',
                step6: '通知をクリック',
                step7: 'ブロックされた通知でWeryAIを見つけ、その他のアイコンをクリックしてから許可をクリック',
            },
        },
    },
    ko: {
        // 韩语
        permissionDialog: {
            title: '알림',
            description: '알림을 활성화하면 생성이 완료될 때까지 기다릴 필요가 없습니다',
            btnClose: '닫기',
            btnAllow: '알림 허용',
        },
        guideDialog: {
            title: '알림 활성화 가이드',
            subtitle: '알림을 활성화하려면 아래 단계를 따르세요',
            imagePlaceholder: '이미지 위치',
            stepAlt: '단계',
            chrome: {
                step1: '더보기 아이콘 클릭',
                step2: '설정 클릭',
                step3: '개인정보 및 보안 클릭',
                step4: '사이트 설정 클릭',
                step5: '알림 클릭',
                step6: 'WeryAI를 찾아 오른쪽의 더보기 아이콘 클릭',
                step7: '허용 클릭',
            },
            edge: {
                step1: '더보기 클릭',
                step2: '설정 클릭',
                step3: '개인정보, 검색 및 서비스 클릭',
                step4: '사이트 권한 클릭',
                step5: '모든 권한 클릭',
                step6: '알림 클릭',
                step7: '차단된 알림에서 WeryAI를 찾아 더보기 아이콘을 클릭한 후 허용 클릭',
            },
        },
    },
    tw: {
        // 繁体中文
        permissionDialog: {
            title: '提示',
            description: '開啟通知，無需停留等待生成完成',
            btnClose: '關閉',
            btnAllow: '允許通知',
        },
        guideDialog: {
            title: '通知啟動操作指南',
            subtitle: '請按照以下步驟啟動通知',
            imagePlaceholder: '圖片位置',
            stepAlt: '步驟',
            chrome: {
                step1: '點擊更多圖示',
                step2: '點擊設定',
                step3: '點擊隱私權與安全性',
                step4: '點擊網站設定',
                step5: '點擊通知',
                step6: '找到WeryAI並點擊右側的更多圖示',
                step7: '點擊允許',
            },
            edge: {
                step1: '點擊更多',
                step2: '點擊設定',
                step3: '點擊隱私權、搜尋和服務',
                step4: '點擊網站權限',
                step5: '點擊所有權限',
                step6: '點擊通知',
                step7: '在不允許通知內找到WeryAI點擊更多圖示後再點擊允許',
            },
        },
    },
    es: {
        // 西班牙语
        permissionDialog: {
            title: 'Consejo',
            description: 'Habilite las notificaciones, no es necesario esperar a que se complete la generación',
            btnClose: 'Cerrar',
            btnAllow: 'Permitir notificaciones',
        },
        guideDialog: {
            title: 'Guía de activación de notificaciones',
            subtitle: 'Siga los pasos a continuación para activar la notificación',
            imagePlaceholder: 'Posición de la imagen',
            stepAlt: 'Paso',
            chrome: {
                step1: 'Haga clic en el ícono Más',
                step2: 'Haga clic en Configuración',
                step3: 'Haga clic en Privacidad y seguridad',
                step4: 'Haga clic en Configuración del sitio',
                step5: 'Haga clic en Notificaciones',
                step6: 'Busque WeryAI y haga clic en el ícono Más a la derecha',
                step7: 'Haga clic en Permitir',
            },
            edge: {
                step1: 'Haga clic en Más',
                step2: 'Haga clic en Configuración',
                step3: 'Haga clic en Privacidad, búsqueda y servicios',
                step4: 'Haga clic en Permisos del sitio',
                step5: 'Haga clic en Todos los permisos',
                step6: 'Haga clic en Notificaciones',
                step7: 'Busque WeryAI en notificaciones bloqueadas, haga clic en el ícono Más y luego en Permitir',
            },
        },
    },
    fr: {
        // 法语
        permissionDialog: {
            title: 'Astuce',
            description: 'Activez les notifications, plus besoin d\'attendre la fin de la génération',
            btnClose: 'Fermer',
            btnAllow: 'Autoriser les notifications',
        },
        guideDialog: {
            title: 'Guide d\'activation des notifications',
            subtitle: 'Veuillez suivre les étapes ci-dessous pour activer la notification',
            imagePlaceholder: 'Position de l\'image',
            stepAlt: 'Étape',
            chrome: {
                step1: 'Cliquez sur l\'icône Plus',
                step2: 'Cliquez sur Paramètres',
                step3: 'Cliquez sur Confidentialité et sécurité',
                step4: 'Cliquez sur Paramètres du site',
                step5: 'Cliquez sur Notifications',
                step6: 'Trouvez WeryAI et cliquez sur l\'icône Plus à droite',
                step7: 'Cliquez sur Autoriser',
            },
            edge: {
                step1: 'Cliquez sur Plus',
                step2: 'Cliquez sur Paramètres',
                step3: 'Cliquez sur Confidentialité, recherche et services',
                step4: 'Cliquez sur Autorisations du site',
                step5: 'Cliquez sur Toutes les autorisations',
                step6: 'Cliquez sur Notifications',
                step7: 'Trouvez WeryAI dans les notifications bloquées, cliquez sur l\'icône Plus puis sur Autoriser',
            },
        },
    },
    de: {
        // 德语
        permissionDialog: {
            title: 'Hinweis',
            description: 'Aktivieren Sie Benachrichtigungen, Sie müssen nicht warten, bis die Generierung abgeschlossen ist',
            btnClose: 'Schließen',
            btnAllow: 'Benachrichtigungen zulassen',
        },
        guideDialog: {
            title: 'Anleitung zur Aktivierung von Benachrichtigungen',
            subtitle: 'Bitte folgen Sie den nachstehenden Schritten, um die Benachrichtigung zu aktivieren',
            imagePlaceholder: 'Bildposition',
            stepAlt: 'Schritt',
            chrome: {
                step1: 'Klicken Sie auf das Mehr-Symbol',
                step2: 'Klicken Sie auf Einstellungen',
                step3: 'Klicken Sie auf Datenschutz und Sicherheit',
                step4: 'Klicken Sie auf Website-Einstellungen',
                step5: 'Klicken Sie auf Benachrichtigungen',
                step6: 'Suchen Sie WeryAI und klicken Sie rechts auf das Mehr-Symbol',
                step7: 'Klicken Sie auf Zulassen',
            },
            edge: {
                step1: 'Klicken Sie auf Mehr',
                step2: 'Klicken Sie auf Einstellungen',
                step3: 'Klicken Sie auf Datenschutz, Suche und Dienste',
                step4: 'Klicken Sie auf Website-Berechtigungen',
                step5: 'Klicken Sie auf Alle Berechtigungen',
                step6: 'Klicken Sie auf Benachrichtigungen',
                step7: 'Suchen Sie WeryAI in blockierten Benachrichtigungen, klicken Sie auf das Mehr-Symbol und dann auf Zulassen',
            },
        },
    },
    ru: {
        // 俄语
        permissionDialog: {
            title: 'Совет',
            description: 'Включите уведомления, не нужно ждать завершения генерации',
            btnClose: 'Закрыть',
            btnAllow: 'Разрешить уведомления',
        },
        guideDialog: {
            title: 'Руководство по активации уведомлений',
            subtitle: 'Пожалуйста, следуйте приведенным ниже шагам для активации уведомления',
            imagePlaceholder: 'Позиция изображения',
            stepAlt: 'Шаг',
            chrome: {
                step1: 'Нажмите на значок "Ещё"',
                step2: 'Нажмите "Настройки"',
                step3: 'Нажмите "Конфиденциальность и безопасность"',
                step4: 'Нажмите "Настройки сайта"',
                step5: 'Нажмите "Уведомления"',
                step6: 'Найдите WeryAI и нажмите на значок "Ещё" справа',
                step7: 'Нажмите "Разрешить"',
            },
            edge: {
                step1: 'Нажмите "Ещё"',
                step2: 'Нажмите "Настройки"',
                step3: 'Нажмите "Конфиденциальность, поиск и службы"',
                step4: 'Нажмите "Разрешения сайта"',
                step5: 'Нажмите "Все разрешения"',
                step6: 'Нажмите "Уведомления"',
                step7: 'Найдите WeryAI в заблокированных уведомлениях, нажмите значок "Ещё", затем "Разрешить"',
            },
        },
    },
    pl: {
        // 波兰语
        permissionDialog: {
            title: 'Wskazówka',
            description: 'Włącz powiadomienia, nie musisz czekać na zakończenie generowania',
            btnClose: 'Zamknij',
            btnAllow: 'Zezwól na powiadomienia',
        },
        guideDialog: {
            title: 'Przewodnik aktywacji powiadomień',
            subtitle: 'Postępuj zgodnie z poniższymi krokami, aby aktywować powiadomienie',
            imagePlaceholder: 'Pozycja obrazu',
            stepAlt: 'Krok',
            chrome: {
                step1: 'Kliknij ikonę Więcej',
                step2: 'Kliknij Ustawienia',
                step3: 'Kliknij Prywatność i bezpieczeństwo',
                step4: 'Kliknij Ustawienia witryny',
                step5: 'Kliknij Powiadomienia',
                step6: 'Znajdź WeryAI i kliknij ikonę Więcej po prawej stronie',
                step7: 'Kliknij Zezwól',
            },
            edge: {
                step1: 'Kliknij Więcej',
                step2: 'Kliknij Ustawienia',
                step3: 'Kliknij Prywatność, wyszukiwanie i usługi',
                step4: 'Kliknij Uprawnienia witryny',
                step5: 'Kliknij Wszystkie uprawnienia',
                step6: 'Kliknij Powiadomienia',
                step7: 'Znajdź WeryAI w zablokowanych powiadomieniach, kliknij ikonę Więcej, a następnie Zezwól',
            },
        },
    },
    pt: {
        // 葡萄牙语
        permissionDialog: {
            title: 'Dica',
            description: 'Ative as notificações, não é necessário esperar a conclusão da geração',
            btnClose: 'Fechar',
            btnAllow: 'Permitir notificações',
        },
        guideDialog: {
            title: 'Guia de ativação de notificações',
            subtitle: 'Siga os passos abaixo para ativar a notificação',
            imagePlaceholder: 'Posição da imagem',
            stepAlt: 'Passo',
            chrome: {
                step1: 'Clique no ícone Mais',
                step2: 'Clique em Configurações',
                step3: 'Clique em Privacidade e segurança',
                step4: 'Clique em Configurações do site',
                step5: 'Clique em Notificações',
                step6: 'Encontre WeryAI e clique no ícone Mais à direita',
                step7: 'Clique em Permitir',
            },
            edge: {
                step1: 'Clique em Mais',
                step2: 'Clique em Configurações',
                step3: 'Clique em Privacidade, pesquisa e serviços',
                step4: 'Clique em Permissões do site',
                step5: 'Clique em Todas as permissões',
                step6: 'Clique em Notificações',
                step7: 'Encontre WeryAI nas notificações bloqueadas, clique no ícone Mais e depois em Permitir',
            },
        },
    },
    it: {
        // 意大利语
        permissionDialog: {
            title: 'Suggerimento',
            description: 'Abilita le notifiche, non è necessario attendere il completamento della generazione',
            btnClose: 'Chiudi',
            btnAllow: 'Consenti notifiche',
        },
        guideDialog: {
            title: 'Guida all\'attivazione delle notifiche',
            subtitle: 'Si prega di seguire i passaggi seguenti per attivare la notifica',
            imagePlaceholder: 'Posizione dell\'immagine',
            stepAlt: 'Passo',
            chrome: {
                step1: 'Fai clic sull\'icona Altro',
                step2: 'Fai clic su Impostazioni',
                step3: 'Fai clic su Privacy e sicurezza',
                step4: 'Fai clic su Impostazioni sito',
                step5: 'Fai clic su Notifiche',
                step6: 'Trova WeryAI e fai clic sull\'icona Altro a destra',
                step7: 'Fai clic su Consenti',
            },
            edge: {
                step1: 'Fai clic su Altro',
                step2: 'Fai clic su Impostazioni',
                step3: 'Fai clic su Privacy, ricerca e servizi',
                step4: 'Fai clic su Autorizzazioni sito',
                step5: 'Fai clic su Tutte le autorizzazioni',
                step6: 'Fai clic su Notifiche',
                step7: 'Trova WeryAI nelle notifiche bloccate, fai clic sull\'icona Altro e poi su Consenti',
            },
        },
    },
    ar: {
        // 阿拉伯语
        permissionDialog: {
            title: 'نصيحة',
            description: 'قم بتمكين الإشعارات، لا حاجة للانتظار حتى اكتمال الإنشاء',
            btnClose: 'إغلاق',
            btnAllow: 'السماح بالإشعارات',
        },
        guideDialog: {
            title: 'دليل تفعيل الإشعارات',
            subtitle: 'يرجى اتباع الخطوات أدناه لتفعيل الإشعار',
            imagePlaceholder: 'موضع الصورة',
            stepAlt: 'خطوة',
            chrome: {
                step1: 'انقر على أيقونة المزيد',
                step2: 'انقر على الإعدادات',
                step3: 'انقر على الخصوصية والأمان',
                step4: 'انقر على إعدادات الموقع',
                step5: 'انقر على الإشعارات',
                step6: 'ابحث عن WeryAI وانقر على أيقونة المزيد على اليمين',
                step7: 'انقر على السماح',
            },
            edge: {
                step1: 'انقر على المزيد',
                step2: 'انقر على الإعدادات',
                step3: 'انقر على الخصوصية والبحث والخدمات',
                step4: 'انقر على أذونات الموقع',
                step5: 'انقر على جميع الأذونات',
                step6: 'انقر على الإشعارات',
                step7: 'ابحث عن WeryAI في الإشعارات المحظورة، انقر على أيقونة المزيد ثم السماح',
            },
        },
    },
    th: {
        // 泰语
        permissionDialog: {
            title: 'คำแนะนำ',
            description: 'เปิดใช้งานการแจ้งเตือน ไม่ต้องรอให้การสร้างเสร็จสิ้น',
            btnClose: 'ปิด',
            btnAllow: 'อนุญาตการแจ้งเตือน',
        },
        guideDialog: {
            title: 'คู่มือการเปิดใช้งานการแจ้งเตือน',
            subtitle: 'โปรดทำตามขั้นตอนด้านล่างเพื่อเปิดใช้งานการแจ้งเตือน',
            imagePlaceholder: 'ตำแหน่งภาพ',
            stepAlt: 'ขั้นตอน',
            chrome: {
                step1: 'คลิกไอคอนเพิ่มเติม',
                step2: 'คลิกการตั้งค่า',
                step3: 'คลิกความเป็นส่วนตัวและความปลอดภัย',
                step4: 'คลิกการตั้งค่าไซต์',
                step5: 'คลิกการแจ้งเตือน',
                step6: 'ค้นหา WeryAI และคลิกไอคอนเพิ่มเติมทางขวา',
                step7: 'คลิกอนุญาต',
            },
            edge: {
                step1: 'คลิกเพิ่มเติม',
                step2: 'คลิกการตั้งค่า',
                step3: 'คลิกความเป็นส่วนตัว การค้นหา และบริการ',
                step4: 'คลิกสิทธิ์ของไซต์',
                step5: 'คลิกสิทธิ์ทั้งหมด',
                step6: 'คลิกการแจ้งเตือน',
                step7: 'ค้นหา WeryAI ในการแจ้งเตือนที่ถูกบล็อก คลิกไอคอนเพิ่มเติมจากนั้นคลิกอนุญาต',
            },
        },
    },
    da: {
        // 丹麦语
        permissionDialog: {
            title: 'Tip',
            description: 'Aktivér notifikationer, ingen grund til at vente på, at genereringen er færdig',
            btnClose: 'Luk',
            btnAllow: 'Tillad notifikationer',
        },
        guideDialog: {
            title: 'Vejledning til aktivering af notifikationer',
            subtitle: 'Følg venligst nedenstående trin for at aktivere notifikationen',
            imagePlaceholder: 'Billedposition',
            stepAlt: 'Trin',
            chrome: {
                step1: 'Klik på ikonet Mere',
                step2: 'Klik på Indstillinger',
                step3: 'Klik på Privatliv og sikkerhed',
                step4: 'Klik på Webstedsindstillinger',
                step5: 'Klik på Notifikationer',
                step6: 'Find WeryAI og klik på ikonet Mere til højre',
                step7: 'Klik på Tillad',
            },
            edge: {
                step1: 'Klik på Mere',
                step2: 'Klik på Indstillinger',
                step3: 'Klik på Privatliv, søgning og tjenester',
                step4: 'Klik på Webstedstilladelser',
                step5: 'Klik på Alle tilladelser',
                step6: 'Klik på Notifikationer',
                step7: 'Find WeryAI i blokerede notifikationer, klik på ikonet Mere og derefter Tillad',
            },
        },
    },
    no: {
        // 挪威语
        permissionDialog: {
            title: 'Tips',
            description: 'Aktiver varsler, ingen grunn til å vente på at genereringen er ferdig',
            btnClose: 'Lukk',
            btnAllow: 'Tillat varsler',
        },
        guideDialog: {
            title: 'Veiledning for aktivering av varsler',
            subtitle: 'Vennligst følg trinnene nedenfor for å aktivere varselet',
            imagePlaceholder: 'Bildeposisjon',
            stepAlt: 'Trinn',
            chrome: {
                step1: 'Klikk på Mer-ikonet',
                step2: 'Klikk på Innstillinger',
                step3: 'Klikk på Personvern og sikkerhet',
                step4: 'Klikk på Nettstedsinnstillinger',
                step5: 'Klikk på Varsler',
                step6: 'Finn WeryAI og klikk på Mer-ikonet til høyre',
                step7: 'Klikk på Tillat',
            },
            edge: {
                step1: 'Klikk på Mer',
                step2: 'Klikk på Innstillinger',
                step3: 'Klikk på Personvern, søk og tjenester',
                step4: 'Klikk på Nettstedstillatelser',
                step5: 'Klikk på Alle tillatelser',
                step6: 'Klikk på Varsler',
                step7: 'Finn WeryAI i blokkerte varsler, klikk på Mer-ikonet og deretter Tillat',
            },
        },
    },
    nl: {
        // 荷兰语
        permissionDialog: {
            title: 'Tip',
            description: 'Schakel meldingen in, u hoeft niet te wachten tot het genereren is voltooid',
            btnClose: 'Sluiten',
            btnAllow: 'Meldingen toestaan',
        },
        guideDialog: {
            title: 'Handleiding voor het activeren van meldingen',
            subtitle: 'Volg de onderstaande stappen om de melding te activeren',
            imagePlaceholder: 'Afbeeldingspositie',
            stepAlt: 'Stap',
            chrome: {
                step1: 'Klik op het pictogram Meer',
                step2: 'Klik op Instellingen',
                step3: 'Klik op Privacy en beveiliging',
                step4: 'Klik op Website-instellingen',
                step5: 'Klik op Meldingen',
                step6: 'Zoek WeryAI en klik rechts op het pictogram Meer',
                step7: 'Klik op Toestaan',
            },
            edge: {
                step1: 'Klik op Meer',
                step2: 'Klik op Instellingen',
                step3: 'Klik op Privacy, zoeken en services',
                step4: 'Klik op Sitemachtigingen',
                step5: 'Klik op Alle machtigingen',
                step6: 'Klik op Meldingen',
                step7: 'Zoek WeryAI in geblokkeerde meldingen, klik op het pictogram Meer en vervolgens op Toestaan',
            },
        },
    },
    id: {
        // 印尼语
        permissionDialog: {
            title: 'Tips',
            description: 'Aktifkan notifikasi, tidak perlu menunggu hingga pembuatan selesai',
            btnClose: 'Tutup',
            btnAllow: 'Izinkan notifikasi',
        },
        guideDialog: {
            title: 'Panduan aktivasi notifikasi',
            subtitle: 'Silakan ikuti langkah-langkah di bawah ini untuk mengaktifkan notifikasi',
            imagePlaceholder: 'Posisi gambar',
            stepAlt: 'Langkah',
            chrome: {
                step1: 'Klik ikon Lainnya',
                step2: 'Klik Setelan',
                step3: 'Klik Privasi dan keamanan',
                step4: 'Klik Setelan situs',
                step5: 'Klik Notifikasi',
                step6: 'Temukan WeryAI dan klik ikon Lainnya di sebelah kanan',
                step7: 'Klik Izinkan',
            },
            edge: {
                step1: 'Klik Lainnya',
                step2: 'Klik Setelan',
                step3: 'Klik Privasi, pencarian, dan layanan',
                step4: 'Klik Izin situs',
                step5: 'Klik Semua izin',
                step6: 'Klik Notifikasi',
                step7: 'Temukan WeryAI di notifikasi yang diblokir, klik ikon Lainnya lalu klik Izinkan',
            },
        },
    },
    tr: {
        // 土耳其语
        permissionDialog: {
            title: 'İpucu',
            description: 'Bildirimleri etkinleştirin, oluşturma tamamlanana kadar beklemenize gerek yok',
            btnClose: 'Kapat',
            btnAllow: 'Bildirimlere izin ver',
        },
        guideDialog: {
            title: 'Bildirim etkinleştirme kılavuzu',
            subtitle: 'Bildirimi etkinleştirmek için lütfen aşağıdaki adımları izleyin',
            imagePlaceholder: 'Görüntü konumu',
            stepAlt: 'Adım',
            chrome: {
                step1: 'Daha fazla simgesine tıklayın',
                step2: 'Ayarlar\'a tıklayın',
                step3: 'Gizlilik ve güvenlik\'e tıklayın',
                step4: 'Site ayarları\'na tıklayın',
                step5: 'Bildirimler\'e tıklayın',
                step6: 'WeryAI\'yi bulun ve sağdaki Daha fazla simgesine tıklayın',
                step7: 'İzin ver\'e tıklayın',
            },
            edge: {
                step1: 'Daha fazla\'ya tıklayın',
                step2: 'Ayarlar\'a tıklayın',
                step3: 'Gizlilik, arama ve hizmetler\'e tıklayın',
                step4: 'Site izinleri\'ne tıklayın',
                step5: 'Tüm izinler\'e tıklayın',
                step6: 'Bildirimler\'e tıklayın',
                step7: 'Engellenen bildirimlerde WeryAI\'yi bulun, Daha fazla simgesine ve ardından İzin ver\'e tıklayın',
            },
        },
    },
}
